import React from 'react';
import { mergeImage } from '../../api-route/mergeImage';
import { BaseURL } from '../../config/axios';
import { Select, SelectItem } from '@nextui-org/react';

const SelectPasparto = ({ setPasspartout, passpartout, setMainImage, frame, id, width, isMobile}) => {
    
    const handleChangePasspartout = async ({ target }) => {
        const { value } = target
        if (!frame) {
            alert('لطفا ابتدا قابی انتخاب کنید')
            return
        }
        setPasspartout(value)
        const image_with_frame = await mergeImage(id, frame, width, value)
        setMainImage(BaseURL + image_with_frame.merged_path)
    }

    const array = [
        { name: 'بدون پاسپارتو', value: 0 },
        { name: '3 سانتی', value: 1 },
        { name: '5 سانتی', value: 2 },
        { name: '8 سانتی', value: 3 },
        { name: '10 سانتی', value: 4 },
        { name: '15 سانتی', value: 5 },
    ]

    return (
        <>
            <div className="my-4" dir='rtl'>
                <Select
                    aria-label=' '
                    variant="bordered"
                    placeholder={isMobile ? "پاسپارتو" : "انتخاب"}
                    selectedKeys={[passpartout]}
                    className={isMobile ? "w-[100px]" : "w-full"}
                    onChange={handleChangePasspartout}
                >
                    {array.map(a => (
                        <SelectItem key={a.value} className="flex-row-reverse" textValue={a.name}>
                            <p className="flex items-center justify-end">{a.name}</p>
                        </SelectItem>
                    ))}
                </Select>
            </div>
        </>
    );
};

export default SelectPasparto;